import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { PersonGbMasterDetailEntryMeta, PersonGbVersionDetailEntryMeta } from '../../../../core/gb-api';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { KopfdatenelementComponent } from '../../../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { KompaktTimepointComponent } from '../../../../shared/kompaktdarstellung/timepoint/kompakt-timepoint.component';

@Component({
  selector: 'cap-persongb-gemeinschaft',
  templateUrl: './persongb-gemeinschaft.component.html',
  styleUrls: ['./persongb-gemeinschaft.component.scss'],
  imports: [KopfdatenelementComponent, KompaktTimepointComponent, TranslatePipe]
})
export class PersongbGemeinschaftComponent implements OnInit {
  @Input()
  public version: PersonGbVersionDetailEntryMeta;
  @Input()
  public master: PersonGbMasterDetailEntryMeta;

  constructor(public translate: TranslateService) {
    keysToTranslate<string>([
      'Personalien',
      'Heimatort',
      'NameDerEltern',
      'NameEhegatte',
      'Geschlecht',
      'Zivilstand',
      'Nationalitaet',
      'Personengruppe',
      'Sprache',
      'Anrede',
      'AHVNummer',
      'AHVVersichertennummer',
      'UidStatus',
      'Gueltig',
      'Adressen'
    ]);
  }

  ngOnInit() {}
}
